import styled from "styled-components";
import { styled as styledMui } from "@mui/material";

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ItemContainer = styled.div`
  width: 100%;
  margin: 0;
  &:first-of-type {
    border-top: 1px solid white;
  }
`;

export const CustomChip = styledMui("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: "5px",
  justifyContent: "space-between",
  borderBottom: `1px solid white`,
  margin: 0,
  cursor: "grabbing",
}));

export const MoveElementContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;
